import React, { FC } from "react"
import { MdKeyboardArrowDown } from "react-icons/md"

interface IProps {
  value: any
  handler?: any
  className?: string
}

export const DropdownButton: FC<IProps> = (props) => {
  const { value, handler, className } = props
  return (
    <div className="rounded-full items-center text-left text-sm sm:text-base px-3 py-1 sm:px-6 sm:py-2 appearance-none bg-[#F5F5F5] text-black border-gray-200 dark:bg-[#0C0C1A] dark:text-white dark:border-[rgba(255,255,255,0.1)]">
      <button className={`text-md font-bold flex items-center justify-center  ` + className} onClick={() => handler()}>
        {value}
        <MdKeyboardArrowDown className="w-6 h-6" />
      </button>
    </div>
  )
}
